"use strict";
/**
 *
 * DateInput
 *
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const clsx_1 = __importDefault(require("clsx"));
const react_datepicker_1 = __importDefault(require("react-datepicker"));
// ui
const Portal_1 = require("@domonda/ui/Portal");
// decorate
require("react-datepicker/dist/react-datepicker.min.css");
const decorate_1 = require("./decorate");
const DateInputPopperPortal = ({ children, }) => {
    if (!children) {
        return null;
    }
    return (react_1.default.createElement(Portal_1.Portal, null,
        react_1.default.createElement("div", { role: "tooltip" }, children)));
};
const DateInput = react_1.default.forwardRef(function DateField(props, ref) {
    const { children, classes, className, popperClassName, calendarClassName } = props, rest = __rest(props, ["children", "classes", "className", "popperClassName", "calendarClassName"]);
    return (react_1.default.createElement("div", { className: clsx_1.default(classes.root, className) },
        react_1.default.createElement(react_datepicker_1.default, Object.assign({ dateFormat: "dd.MM.yyyy", popperContainer: DateInputPopperPortal, popperPlacement: "bottom", popperModifiers: {
                preventOverflow: {
                    enabled: true,
                },
            } }, rest, { ref: ref, popperClassName: clsx_1.default(classes.popper, popperClassName), calendarClassName: clsx_1.default(classes.calendar, calendarClassName) }))));
});
if (process.env.NODE_ENV !== 'production') {
    DateInput.displayName = 'DateInput';
}
const StyledDateInput = decorate_1.decorate(DateInput);
exports.DateInput = StyledDateInput;
